<template>
  <div id="hres33u">
    <hrms-search-box-table v-show="indexDisp"
            :data="index"
            :nowLang="dash.nowLang"
            :columns="columns[dash.nowLang].index"
            :receivedStore="receivedHres33uIndex"
            searchBoxAlias="approve"
            :detailEvent="detailEvent"
            :approveEvent="postHres33uSendApprove" />
            
    <detail1 v-show="detailDisp.tab1"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab1"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <detail2 v-show="detailDisp.tab2"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab2"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :tab2Tab6Table="columns[dash.nowLang].tab2Tab6Table"
            :tab2Tab7Table="columns[dash.nowLang].tab2Tab7Table" />

    <detail3 v-show="detailDisp.tab3"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab3"
            :toggle="toggle"
            :nowLang="dash.nowLang" 
            :tab3Table1="columns[dash.nowLang].tab3Table1"
            :tab3Table2="columns[dash.nowLang].tab3Table2" />

    <detail4 v-show="detailDisp.tab4"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab4"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :tab4Table1="columns[dash.nowLang].tab4Table1"
            :tab4Table2="columns[dash.nowLang].tab4Table2" />

    <detail5 v-show="detailDisp.tab5"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab5"
            :toggle="toggle"
            :nowLang="dash.nowLang" />

    <detail6 v-show="detailDisp.tab6"
            :labels="labels[dash.nowLang]"
            :buttonLabels="constLabels.button[dash.nowLang]"
            :detail="detail.tab6"
            :toggle="toggle"
            :nowLang="dash.nowLang"
            :tab6Table1="columns[dash.nowLang].tab6Table1"
            :tab6Table2="columns[dash.nowLang].tab6Table2" />

  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hres33u/mutation-types'
import constLabels from 'src/../config/label'
import detail1 from 'components/hres33u/detail1'
import detail2 from 'components/hres33u/detail2'
import detail3 from 'components/hres33u/detail3'
import detail4 from 'components/hres33u/detail4'
import detail5 from 'components/hres33u/detail5'
import detail6 from 'components/hres33u/detail6'
import moment from 'moment'

export default {
  name: 'hres33u',
  data () {
    return {
      dash: this.$parent.$parent.$parent,
      dtereq: moment().format('DD/MM/YYYY'),
      constLabels: constLabels
    }
  },
  created () {
    this.receivedHres33uColumnsLabels()
    this.receivedHres33uIndex()
  },
  computed: {
    codempid () {
      let currentUser = this.dash.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRES33U_INDEX_DISP,
      detailDisp: types.GET_HRES33U_DETAIL_DISP,
      columns: types.GET_HRES33U_COLUMNS,
      labels: types.GET_HRES33U_LABELS,
      index: types.GET_HRES33U_INDEX,
      indexSelected: types.GET_HRES33U_INDEX_SELECTED,
      detail: types.GET_HRES33U_DETAIL
    })
  },
  methods: {
    detailEvent (dataRow) {
      if (dataRow.numseq) {
        let searchParams = {
          p_typ: dataRow.typ,
          p_codempid: dataRow.codempid,
          p_dtereq: dataRow.dtereq,
          p_numseq: dataRow.numseq
        }
        this.receivedHres33uDetail(searchParams)
        this.toggle('detail' + dataRow.typ)
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRES33U_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRES33U_PAGE,
      receivedHres33uColumnsLabels: types.RECEIVED_HRES33U_COLUMNS_LABELS,
      receivedHres33uIndex: types.RECEIVED_HRES33U_INDEX,
      receivedHres33uDetail: types.RECEIVED_HRES33U_DETAIL,
      postHres33uSendApprove: types.POST_HRES33U_SEND_APPROVE
    })
  },
  components: {
    detail1,
    detail2,
    detail3,
    detail4,
    detail5,
    detail6
  }
}
</script>
<style src="./style.scss" lang='scss'></style>




// WEBPACK FOOTER //
// component.vue?7c8f74d4